<template>
  <component
    :is="tag"
    class="ds-card"
  >
    <div class="ds-card-header">
      <slot name="header" />
    </div>
    <div class="ds-card-content">
      <slot />
    </div>
    <div class="ds-card-footer">
      <slot name="footer" />
    </div>
  </component>
</template>

<script>
export default {
  name: 'DsCard',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables.styl"

.ds-card {
  padding: 16px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  overflow-y auto;
  scrollbar-width: thin;
  background: $white;
  border-radius: 4px;

  @media $sm-and-up {
    padding: 24px 24px 32px 24px;
  }

  &-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  box-shadow: $nx-elevation-700;

  >>> a:not(.v-btn) {
    color: $nx-secondary--darken-1;
    text-decoration: none;

    &.disabled {
      pointer-events none;
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
}
</style>
